import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['title', 'text', 'email'];

  connect () {
    addEventListener('openModal', (e) => {
      this.titleTarget.innerHTML = e.detail.title
      this.textTarget.innerHTML = e.detail.text
      this.emailTarget.innerHTML = e.detail.email
      this.actionPath = e.detail.actionPath
      this.redirectTo = e.detail.redirectTo
      this.open()
    })
  }

  open () {
    this.element.classList.remove('hide')
  }

  close () {
    this.element.classList.add('hide')
  }

  submit () {
    this.close()

    Rails.ajax({
      type: 'delete',
      url: this.actionPath,
      success: () => {
        location.href = this.redirectTo
      },
      error: () => {
        // The Rails controller will take care of the flash error
        location.href = this.redirectTo
      }
    })
  }
}
